var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.video.type,
      callback: function ($$v) {
        _vm.$set(_vm.form.video, "type", $$v);
      },
      expression: "form.video.type"
    }
  }, [_vm._l(_vm.types, function (item) {
    return [_c('v-radio', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })];
  })], 2), _c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "URL을 입력해주세요"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.video.link,
      callback: function ($$v) {
        _vm.$set(_vm.form.video, "link", $$v);
      },
      expression: "form.video.link"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }